import React from 'react';
import { components } from 'react-select';

function CustomGroupsOption(props) {
  const { data } = props;
  const { isParent, isLinked } = data;

  return (
    <components.Option 
      {...props} 
      onClick={() => {return}}
      className={`${isParent || isLinked ? "option-disabled" : ""}`}
    >
      <div className="d-flex align-items-center pl-1 pr-1">
        <span>{data.label}</span>
      </div>
    </components.Option>
  )
}

export default CustomGroupsOption